import dotProp from 'dot-prop-immutable'
import {
  ACCEPT_GAUGE,
  REFRESH_GAUGE,
  REMOVE_WALLPAPER,
  SELECT_WALLPAPER,
  START_GAUGING_UP,
  WALLPAPERS_ARE_LOADING,
  WALLPAPERS_FAILED,
  WALLPAPERS_LOADED,
  REFRESH_REAL_METER,
} from '../constants/wallpapersActions'
import calibreBackground from '../repositories/calibreBackground'
import uploadBackground from '../repositories/uploadBackground'
import { setBGCalibration } from './project/background'
import {mapImageUrl} from "../utils/mapImageUrl";

export const selectWallpaper = index => ({ type: SELECT_WALLPAPER, index })
export const removeWallpaper = index => ({ type: REMOVE_WALLPAPER, index })

export const loadWallpapers = getWallpapers => (dispatch, ownState) => {
  if (0 !== dotProp.get(ownState(), 'wallpapers.images', []).length) {
    return
  }

  dispatch({ type: WALLPAPERS_ARE_LOADING })
  getWallpapers()
    .then(res =>
      res.map(w => {
        const n = {
          id: w.id,
          src: w.content_url,
          isCustom: w.is_custom === true,
        }

        if (w.per_meter !== null) {
          n.calibration = { perMeter: w.per_meter }
        }

        return n
      })
    )
    .then(res => dispatch({ type: WALLPAPERS_LOADED, images: res }))
    .catch(err => dispatch({ type: WALLPAPERS_FAILED, message: err.message }))
}

export const startGaugingUp = () => ({ type: START_GAUGING_UP })
export const refreshGauge = (index, perMeter) => dispatch => {
  dispatch({ type: REFRESH_GAUGE, index, perMeter })
  dispatch(setBGCalibration(perMeter))
}

export const finishGaugingUp = (disableOnly = false, fetch) => (dispatch, ownState) => {
  if (true === disableOnly) {
    return dispatch({ type: ACCEPT_GAUGE })
  }

  const currentState = ownState()
  const index = dotProp.get(currentState, `wallpapers.selectedIndex`, 0)
  const current = dotProp.get(currentState, `wallpapers.images.${index}`)

  if (undefined === current.calibration || 0 === current.calibration.perMeter) {
    return alert('Wartość kalibracji jest niepoprawna!')
  }

  if (fetch === undefined) {
    return alert('Nie można połączyć się z serwerem!')
  }

  const updateBackground = calibreBackground(fetch)
  updateBackground(current.id, current.calibration.perMeter).then(() => dispatch({ type: ACCEPT_GAUGE }))
}

export const uploadWallpapers = (accepted, rejected) => (dispatch, ownState) => {
  dispatch({ type: WALLPAPERS_ARE_LOADING })
  const currentImages = dotProp.get(ownState(), 'wallpapers.images', [])

  Promise.all(accepted.map(file => uploadBackground(fetch)(file)))
    .then(responses =>
      responses.map(res => ({
        id: res.id,
        src: mapImageUrl(res.content_url),
        isCustom: true,
        first: true
      }))
    )
    .then(actions => {
      dispatch({ type: WALLPAPERS_LOADED, images: [...actions, ...currentImages] })
    })
    .catch(err => dispatch({ type: WALLPAPERS_FAILED, message: err.message }))
}

export const changeRealMeter = (wallId, mes) => (dispatch, ownState) => {
  const currentState = ownState()
  const current = dotProp.get(currentState, `wallpapers.images.${wallId}`)
  const { perMeter, realMeter } = { perMeter: 100, realMeter: 100, ...current.calibration }
  dispatch({ type: REFRESH_REAL_METER, index: wallId, perMeter: Number(mes? mes: realMeter) })

  const realPerMeter = (perMeter / Number(mes? mes: realMeter)) * realMeter
  refreshGauge(wallId, realPerMeter)(dispatch)
}



// WEBPACK FOOTER //
// ./src/actions/wallpapers.js